import { useCallback } from "react";
import axios from 'axios';
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

const API_BASE = `${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/notification`;

export default function useNotification() {
  // Get paginated notifications for current user
  const getNotifications = useCallback(async (pageSize = 20, pageNumber = 1, includeCleared = false) => {
    try {
      const response = await axios.get(
        API_BASE,
        { params: { pageSize, pageNumber, includeCleared } }
      );
      return response.data;
    } catch (e) {
      return { items: [], totalCount: 0, totalPages: 0 };
    }
  }, []);

  // Get unread notification count for badge
  const getUnreadCount = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE}/unread-count`);
      return response.data;
    } catch (e) {
      return 0;
    }
  }, []);

  // Get active (non-cleared) notification count for badge
  const getActiveCount = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE}/active-count`);
      return response.data;
    } catch (e) {
      return 0;
    }
  }, []);

  // Mark single notification as read
  const markAsRead = useCallback(async (notificationId) => {
    try {
      await axios.patch(`${API_BASE}/${notificationId}/read`);
      return true;
    } catch (e) {
      return false;
    }
  }, []);

  // Clear (archive) single notification
  const clearNotification = useCallback(async (notificationId) => {
    try {
      await axios.patch(`${API_BASE}/${notificationId}/clear`);
      return true;
    } catch (e) {
      return false;
    }
  }, []);

  // Clear all notifications for current user
  const clearAllNotifications = useCallback(async () => {
    try {
      await axios.patch(`${API_BASE}/clear-all`);
      return true;
    } catch (e) {
      return false;
    }
  }, []);

  // Mark all notifications as read
  const markAllAsRead = useCallback(async () => {
    try {
      await axios.patch(`${API_BASE}/read-all`);
      return true;
    } catch (e) {
      return false;
    }
  }, []);

  return {
    getNotifications,
    getUnreadCount,
    getActiveCount,
    markAsRead,
    clearNotification,
    clearAllNotifications,
    markAllAsRead
  };
}
